import { Exchange, Hosting, Office365, Wordpress, Zimbra } from '../assets-icon-svg/icons';

const webIcons = {
  Hosting,
  Office365,
  Exchange,
  Zimbra,
  Wordpress,
};

export default webIcons;
